export default __webpack_public_path__ + "static/media/lets-build-accelerator-logo.a159ebd1.jpg";